import { render, staticRenderFns } from "./EntityViewConfiguration.vue?vue&type=template&id=440389f5&scoped=true"
import script from "./EntityViewConfiguration.vue?vue&type=script&lang=js"
export * from "./EntityViewConfiguration.vue?vue&type=script&lang=js"
import style0 from "./EntityViewConfiguration.vue?vue&type=style&index=0&id=440389f5&prod&scoped=true&lang=scss"
import style1 from "./EntityViewConfiguration.vue?vue&type=style&index=1&id=440389f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440389f5",
  null
  
)

export default component.exports